import { Component, Input, ViewEncapsulation, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { Client } from 'src/providers/client/client';
import { MenuController } from '@ionic/angular';
import { MenuData } from '../models/menu-data';
import { Events } from 'src/providers/events/events';
import { Subscription } from 'rxjs';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

@Component({
    selector: 'tidy-menu-address-selector',
    templateUrl: 'tidy-menu-address-selector.component.html',
    styleUrls: ['./tidy-menu-address-selector.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TidyMenuAddressSelectorComponent implements OnChanges, OnDestroy  {
  addressList: any;
  @Input() menuData: MenuData;
  cont = 0;
  addressSubscription: Subscription;
  addressUpdatedSubscription: Subscription;

  constructor(
    private client: Client,
    private events: Events,
    private menu: MenuController,
    private navCtrl: CustomNavController
  ) {
    this.subscribeAddressAddedRemoved();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.menuData) {
      this.addressList = this.menuData.addresses;
    }
  }

  async goToManageAddresses() {
    await this.menu.close();
    this.navCtrl.navigateForward('manage-addresses');
  }

  async changeAddress(address) {
    this.cont++;
    await this.menu.close();
    this.events.publish('address:changed', address);
    this.navCtrl.navigateForward(['my-cleanings', this.cont]);
  }

  subscribeAddressAddedRemoved() {
    this.addressSubscription = this.events.subscribe('address:add-rm', () => {
      this.getAddresses();
    });
    this.addressUpdatedSubscription = this.events.subscribe('address:updated', () => {
      this.getAddresses();
    });
  }

  async getAddresses() {
    this.addressList = await this.client.getAddresses();
  }

  ngOnDestroy() {
    this.addressSubscription.unsubscribe();
    this.addressUpdatedSubscription.unsubscribe();
  }
}
